import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftLong,
  faDownload,
  faEye,
} from '@fortawesome/free-solid-svg-icons';
import PageLoading from '../../common/components/elements/PageLoading';
import { getBrokerActiveCustomerInformation } from '../../features/activeCustomer/activeCustomerActions';
import {
  ActiveCustomerDetailsStyles,
  ReadMailBtn,
  TableRowStyle,
  CustomerDetailsHeader,
  BackBtnCustom,
  ActionCard,
  SectionCard,
  SectionHeader,
  SectionBadge,
  CustomTable,
  EmptyState,
  EmptyStateIcon,
  BtnWhiteOutline,
  BadgeCustom,
} from './ActiveCustomerDetails.styles';
// import { useTourContext } from '../../context/useTourContext';
import ErrorComponent from '../../common/components/ErrorComponent';
import SchedaAnagrafica from './parts/SchedaAnagrafica';
import ContactInformation from './parts/ContactInformation';
import { getQuoteTypes } from '../../features/utilities/utilitiesActions';
import { getProductNameForUrl, safeCapitalizeWords } from '../../common/constants';
import { apiDownloadDocument } from '../../services/axios-client/axeCommons';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackActiveCustDetails } from '../../common/utils/joyrideCallbacks';
// import { activeCustomerDetailsSteps } from '../../common/utils/joyrideSteps';

function ActiveCustomerDetails() {
  const { activeClientId } = useParams();
  const navigate = useNavigate();
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);
  const {
    active_customer: {
      activeCustomer,
      activeQuotes,
      insurance_requests,
      loading,
      gmails,
      contacts,
      after_sales,
      error,
    },
  } = useSelector((store) => store.activeCustomers);

  const newQuotation = (activeCustomerId, productType) => {
    if (productType === 'auto') {
      navigate('/quote/auto', {
        state: {
          activeCustomerId,
        },
      });
    }
    if (productType === 'autocarro') {
      navigate('/quote/autocarro', {
        state: {
          activeCustomerId,
        },
      });
    }
    if (productType === 'profession') {
      navigate('/quote/profession', {
        state: {
          activeCustomerId,
        },
      });
    }
    if (productType === 'infortuni') {
      navigate('/quote/metlife/meno-male-gold', {
        state: {
          activeCustomerId,
        },
      });
    }
  };

  const getTypeName = (type) => {
    if (type === 'replacement') {
      return 'Sostituzione';
    }
    if (type === 'modification') {
      return 'Modifica Dati';
    }
    if (type === 'cancellation') {
      return 'Cessazione';
    }
    if (type === 'accident') {
      return 'Sinistro';
    }
    if (type === 'send_document') {
      return 'Invia Documenti';
    }

    if (type === 'suspension') {
      return 'Sospensione';
    }

    return '';
  };

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('activeClientSinglePage') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('activeClientSinglePage')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('activeClientSinglePage');
  //   setState({ run: true, tourActive: true });
  // };

  const navigateToQuoteScreen = (afterSale) => {
    if (afterSale.type === 'accident') {
      navigate(`/after-sale/purchase/accident/${afterSale.after_sale_id}`);
    }

    if (afterSale.type === 'cancellation') {
      navigate(`/after-sale/purchase/cancellation/${afterSale.after_sale_id}`);
    }

    if (afterSale.type === 'modification') {
      navigate(`/after-sale/purchase/modification/${afterSale.after_sale_id}`);
    }

    if (afterSale.type === 'replacement') {
      navigate(`/after-sale/purchase/replacement/${afterSale.after_sale_id}`);
    }

    if (afterSale.type === 'suspension') {
      navigate(`/after-sale/purchase/suspension/${afterSale.after_sale_id}`);
    }
  };

  const downloadDocument = async (documentId) => {
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const getQuoteTypeName = (quoteType) => {
    const foundType = quoteTypes.find((type) => type.id === quoteType);
    return foundType ? foundType.name : quoteType;
  };

  const navigateToPurchasedQuoteScreen = (quote) => {
    if (quote.quotation_status.id !== 7) {
      navigate(`/quotes/${getProductNameForUrl(quote?.product?.id)}/purchase/${quote.request_token}`);
      return;
    }

    if (quote.insurance_request.is_offline === 1) {
      navigate(`/quotes/purchased/${quote.id}/quotation/offline`);
    } else {
      if (quote.quote_type === 'assistenza_stradale') {
        navigate(`/quotes/purchased/${quote.id}/quotation/assistenza-stradale`);
      }

      if (quote.quote_type === 'cristalli') {
        navigate(`/quotes/purchased/${quote.id}/quotation/cristalli`);
      }

      if (quote.quote_type === 'collisione') {
        navigate(`/quotes/purchased/${quote.id}/quotation/collisione`);
      }

      if (quote.quote_type === 'infortuni_conducente') {
        navigate(`/quotes/purchased/${quote.id}/quotation/infortuni-conducente`);
      }
      // ? Updated Logic
      if ([1, 2, 3].includes(quote.product.id)) {
        navigate(
          `/quotes/purchased/${quote.id}/quotation/${quote.product.slug}`,
        );
      }

      if (quote.product.id === 5) {
        // navigate(`/quotes/purchased/${quote.id}/quotation/metlife`);
        //! No Metlife Anymore
      }

      if (quote.product.id === 4) {
        navigate(`/quotes/purchased/${quote.id}/quotation/profession`);
      }

      if (quote.product.id === 6) {
        //! No Infodrive Anymore
      }

      if (quote.product.id === 8) {
        navigate(`/quotes/purchased/${quote.id}/quotation/travel`);
      }

      if (quote.product.id === 9) {
        navigate(`/quotes/purchased/${quote.id}/quotation/tutela-legale`);
      }

      if (quote.product.id === 10) {
        navigate(`/quotes/purchased/${quote.id}/quotation/commercial`);
      }

      if (quote.product.id === 11) {
        navigate(`/quotes/purchased/${quote.id}/quotation/casa`);
      }

      if (quote.product.id === 12) {
        navigate(`/quotes/purchased/${quote.id}/quotation/salute`);
      }

      if (quote.product.id === 13) {
        navigate(
          `/quotes/purchased/${quote.id}/quotation/ancillari-auto`,
        );
      }

      if (quote.product.id === 14) {
        navigate(
          `/quotes/purchased/${quote.id}/quotation/sanitaria-stranieri`,
        );
      }

      if (quote.product.id === 15) {
        navigate(
          `/quotes/purchased/${quote.id}/quotation/rc-professionale-sanita`,
        );
      }
    }
  };

  const sendToInsuranceRequestQuotationsList = (ir) => {
    if (ir.product_id === '1' || ir.product_id === '3') {
      navigate(`/quotes/${ir.request_token}`);
    } else if (ir.product_id === '2') {
      navigate(`/quotes/moto/${ir.request_token}`);
    } else if (ir.product_id === '4') {
      navigate(`/quotes/profession/${ir.request_token}`);
    } else if (ir.product_id === '5') {
      navigate(`/quotes/metlife/${ir.request_token}`);
    } else if (ir.product_id === '8') {
      navigate(`/quotes/travel/${ir.request_token}`);
    } else if (ir.product_id === '9') {
      navigate(`/quotes/tutela-legale/${ir.request_token}`);
    } else if (ir.product_id === '10') {
      navigate(`/quotes/commercial/${ir.request_token}`);
    } else if (ir.product_id === '11') {
      navigate(`/quotes/casa/${ir.request_token}`);
    } else if (ir.product_id === '12') {
      navigate(`/quotes/salute/${ir.request_token}`);
    } else if (ir.product_id === '13') {
      navigate(`/quotes/ancillari-auto/${ir.request_token}`);
    } else if (ir.product_id === '14') {
      navigate(`/quotes/sanitaria-stranieri/${ir.request_token}`);
    } else if (ir.product_id === '15') {
      navigate(`/quotes/rc-professionale-sanita/${ir.request_token}`);
    }
  };

  const navigateToPostVendita = () => {
    navigate('/after-sale', {
      state: {
        type: 'redirect',
        data: {
          activeCustomerId: activeCustomer.id,
          search:
            activeCustomer.gender === 'G'
              ? activeCustomer.business_name
              : `${activeCustomer.name} ${activeCustomer.surname}`,
        },
      },
    });
  };

  // const createClientAppAccount = (id) => {
  //   requestClientAppAccount(id, () => {
  //     getBrokerActiveCustomerInformation(activeClientId);
  //     generalAlertSuccess('Account e stato creato');
  //   });
  // };

  useEffect(() => {
    getBrokerActiveCustomerInformation(activeClientId);
  }, []);

  useEffect(() => {
    if (quoteTypes.length === 0) {
      getQuoteTypes();
    }
  }, [quoteTypes]);

  if (loading) {
    return <PageLoading />;
  }

  return error === null ? (
    <ActiveCustomerDetailsStyles>
      {/* Header Section */}
      <CustomerDetailsHeader>
        <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
          <div className="d-flex align-items-center">
            <BackBtnCustom id="back-button" onClick={() => navigate(-1)}>
              <FontAwesomeIcon icon={faArrowLeftLong} />
            </BackBtnCustom>
            <div>
              <h2 className="mb-1" style={{ fontWeight: '600' }}>
                {activeCustomer.gender !== 'G'
                  ? `${activeCustomer.name} ${activeCustomer.surname}`
                  : activeCustomer.business_name}
              </h2>
              <p className="mb-0" style={{ opacity: '0.9', fontSize: '0.9rem' }}>
                {activeCustomer.gender !== 'G' ? 'Persona Fisica' : 'Persona Giuridica'}
              </p>
            </div>
          </div>

          <div className="d-flex flex-column flex-md-row gap-3">
            <ActionCard className="active-client-single-page-one">
              <p className="mb-2">Gestisci</p>
              <BtnWhiteOutline
                type="button"
                className="w-100"
                onClick={() => navigateToPostVendita()}
              >
                Post Vendita
              </BtnWhiteOutline>
            </ActionCard>

            <ActionCard className="active-client-single-page-two">
              <p className="mb-2">Nuovo Preventivo</p>
              <div className="btn-group w-100 gap-2" role="group">
                <BtnWhiteOutline
                  type="button"
                  onClick={() => newQuotation(activeClientId, 'auto')}
                  style={{ fontSize: '0.85rem' }}
                >
                  Auto
                </BtnWhiteOutline>
                <BtnWhiteOutline
                  type="button"
                  onClick={() => newQuotation(activeClientId, 'autocarro')}
                  style={{ fontSize: '0.85rem' }}
                >
                  Autocarro
                </BtnWhiteOutline>
                <BtnWhiteOutline
                  type="button"
                  onClick={() => newQuotation(activeClientId, 'profession')}
                  style={{ fontSize: '0.85rem' }}
                >
                  Professionale
                </BtnWhiteOutline>
              </div>
            </ActionCard>
          </div>
        </div>
      </CustomerDetailsHeader>

      {/* Customer Information Cards */}
      <div className="row g-4 mb-4">
        <SchedaAnagrafica activeCustomer={activeCustomer} />

        <ContactInformation
          activeCustomer={activeCustomer}
          activeClientId={activeClientId}
        />
      </div>

      {/* Preventivi Fatti */}
      <SectionCard className="active-client-single-page-five">
        <SectionHeader>
          <h5>Preventivi Fatti</h5>
          <SectionBadge>{insurance_requests.length}</SectionBadge>
        </SectionHeader>
        <div className="table-responsive">
          <CustomTable className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Prodotto</th>
                <th>Targa</th>
                <th>Data D'inizio</th>
                <th>Creato a</th>
              </tr>
            </thead>
            <tbody>
              {insurance_requests.length !== 0 ? (
                insurance_requests.map((request, index) => (
                  <TableRowStyle
                    key={index}
                    onClick={() => sendToInsuranceRequestQuotationsList(request)}
                  >
                    <td>
                      <BadgeCustom style={{ background: '#e3f2fd', color: '#1976d2' }}>
                        {request.request_token}
                      </BadgeCustom>
                    </td>
                    <td><strong>{request.product.name}</strong></td>
                    <td>{request.vehicle_plate || '-'}</td>
                    <td>{moment(request.policy_effective_date).format('DD.MM.YYYY')}</td>
                    <td>{moment(request.created_at).format('DD.MM.YYYY HH:mm')}</td>
                  </TableRowStyle>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>
                    <EmptyState>
                      <EmptyStateIcon>📋</EmptyStateIcon>
                      <p className="mb-0">Nessun Preventivo Trovato!</p>
                    </EmptyState>
                  </td>
                </tr>
              )}
            </tbody>
          </CustomTable>
        </div>
      </SectionCard>

      {/* Polizze emesse */}
      <SectionCard className="active-client-single-page-six">
        <SectionHeader>
          <h5>Polizze Emesse</h5>
          <SectionBadge>{activeQuotes.length}</SectionBadge>
        </SectionHeader>
        <div className="table-responsive">
          <CustomTable className="table">
            <thead>
              <tr>
                <th>Azioni</th>
                <th>Detagli</th>
                <th>Premio</th>
                <th>Data Di Emissione</th>
                <th>Data Di Scadenza</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              {activeQuotes.length !== 0 ? (
                activeQuotes.map((quote, index) => (
                  <TableRowStyle
                    key={index}
                  >
                    <td>
                      {' '}
                      <div className="document-actions">
                        <div className="d-flex align-items-center justify-content-center flex-column gap-2">
                          {quote.document_id !== null && (
                            <button
                              className="btn-download w-100"
                              onClick={quote.document_id !== null ? () => downloadDocument(quote.document_id) : () => { }}
                            >
                              <FontAwesomeIcon icon={faDownload} />
                              Scarica Polizza
                            </button>
                          )}
                          <button
                            className="btn-upload w-100"
                            onClick={() => navigateToPurchasedQuoteScreen(quote)}
                          >
                            <FontAwesomeIcon icon={faEye} />
                            Apri Polizza
                          </button>
                        </div>
                      </div>

                    </td>
                    <td>
                      <small>Compagnia:</small>
                      {' '}
                      <br />
                      {' '}
                      <strong>{quote.company !== null ? quote.company.name : quote.preventivas_company.company_name}</strong>
                      <br />
                      <small>Prodotto:</small>
                      {' '}
                      <br />
                      {' '}
                      {quote.risk_product_name ? safeCapitalizeWords(quote.risk_product_name) : getQuoteTypeName(quote.quote_type)}
                    </td>
                    <td>
                      <span style={{ color: '#00a651', fontWeight: '600' }}>
                        &euro;
                        {' '}
                        {parseFloat(quote.amount).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </span>
                    </td>
                    <td>{moment(quote.insurance_request.policy_effective_date).toDate().toLocaleDateString('it-IT')}</td>
                    <td>{moment(quote.insurance_request.policy_effective_date).add(1, 'years').toDate().toLocaleDateString('it-IT')}</td>
                    <td>
                      <BadgeCustom style={{ background: '#e8f5e9', color: '#2e7d32' }}>
                        {quote.quotation_status.name}
                      </BadgeCustom>
                    </td>
                  </TableRowStyle>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>
                    <EmptyState>
                      <EmptyStateIcon>📄</EmptyStateIcon>
                      <p className="mb-0">Nessuna Polizza Emessa Trovata!</p>
                    </EmptyState>
                  </td>
                </tr>
              )}
            </tbody>
          </CustomTable>
        </div>
      </SectionCard>

      {/* Attivita Post Vendita */}
      <SectionCard className="active-client-single-page-seven">
        <SectionHeader>
          <h5>Attività Post Vendita</h5>
          <SectionBadge>{after_sales.length}</SectionBadge>
        </SectionHeader>
        <div className="table-responsive">
          <CustomTable className="table">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Prodotto</th>
                <th>Email</th>
                <th>Nota</th>
                <th>Targa</th>
                <th>Documenti Inviati</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {after_sales.length > 0 ? (
                after_sales.map((afterSale, index) => (
                  <TableRowStyle
                    key={index}
                    onClick={() => navigateToQuoteScreen(afterSale)}
                  >
                    <td>
                      <BadgeCustom style={{ background: '#fff3e0', color: '#e65100' }}>
                        {getTypeName(afterSale.type)}
                      </BadgeCustom>
                    </td>
                    <td><strong>{afterSale.product_name}</strong></td>
                    <td>{afterSale.email || <span style={{ color: '#999' }}>-</span>}</td>
                    <td>{afterSale.nota || <span style={{ color: '#999' }}>-</span>}</td>
                    <td>{afterSale.vehicle_plate || <span style={{ color: '#999' }}>-</span>}</td>
                    <td>{afterSale.document_names ? `Inviati: ${afterSale.document_names}` : <span style={{ color: '#999' }}>-</span>}</td>
                    <td>{moment(afterSale.created_at).toDate().toLocaleDateString('it-IT')}</td>
                  </TableRowStyle>
                ))
              ) : (
                <tr>
                  <td colSpan={7}>
                    <EmptyState>
                      <EmptyStateIcon>📦</EmptyStateIcon>
                      <p className="mb-0">Nessuna Attività Post Vendita Trovata!</p>
                    </EmptyState>
                  </td>
                </tr>
              )}
            </tbody>
          </CustomTable>
        </div>
      </SectionCard>

      {/* Storico Contatti */}
      <SectionCard className="active-client-single-page-eight">
        <SectionHeader>
          <h5>Storico Contatti</h5>
          <SectionBadge>{contacts.length}</SectionBadge>
        </SectionHeader>
        <div className="table-responsive">
          <CustomTable className="table">
            <thead>
              <tr>
                <th>Intermediario</th>
                <th>Metodo Di Contatto</th>
                <th>Messaggio</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {contacts.length > 0 ? (
                contacts.map((contact, index) => (
                  <TableRowStyle key={index}>
                    <td><strong>{`${contact.broker_name} ${contact.broker_surname}`}</strong></td>
                    <td>
                      <BadgeCustom
                        style={{
                          background: contact.contact_type === 1 ? '#e3f2fd' : '#f3e5f5',
                          color: contact.contact_type === 1 ? '#1976d2' : '#7b1fa2',
                        }}
                      >
                        {contact.contact_type === 1 ? '📧 Email' : '💬 SMS'}
                      </BadgeCustom>
                    </td>
                    <td>{contact.message}</td>
                    <td>{moment(contact.created_at).toDate().toLocaleDateString('it-IT')}</td>
                  </TableRowStyle>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    <EmptyState>
                      <EmptyStateIcon>📞</EmptyStateIcon>
                      <p className="mb-0">Nessuno Storico Contatti Trovato!</p>
                    </EmptyState>
                  </td>
                </tr>
              )}
            </tbody>
          </CustomTable>
        </div>
      </SectionCard>

      {/* Lista Email */}
      <SectionCard className="active-client-single-page-nine">
        <SectionHeader>
          <h5>Lista Email</h5>
          <SectionBadge>{gmails.length}</SectionBadge>
        </SectionHeader>
        <div className="table-responsive">
          <CustomTable className="table">
            <thead>
              <tr>
                <th>Oggetto</th>
                <th>Da Nome</th>
                <th>A Nome</th>
                <th>Data</th>
                <th>Quotazione</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {gmails.length > 0 ? (
                gmails.map((mail, index) => (
                  <tr key={index}>
                    <td><strong>{mail.subject}</strong></td>
                    <td>{mail.fromName}</td>
                    <td>{mail.toName}</td>
                    <td>{moment(mail.date).toDate().toLocaleDateString('it-IT')}</td>
                    <td>{mail.insurance_request.product.name}</td>
                    <td>
                      <ReadMailBtn>
                        <Link to={`/clients/email/${mail.id}`} className="btn btn-sm btn-outline-success">
                          Leggi
                        </Link>
                      </ReadMailBtn>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6}>
                    <EmptyState>
                      <EmptyStateIcon>📧</EmptyStateIcon>
                      <p className="mb-0">Nessuna Mail Trovata!</p>
                    </EmptyState>
                  </td>
                </tr>
              )}
            </tbody>
          </CustomTable>
        </div>
      </SectionCard>
    </ActiveCustomerDetailsStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}

export default ActiveCustomerDetails;
